<apx-chart [series]="chartBarSparkline1Options.series" [chart]="commonBarSparklineOptions.chart"
  [plotOptions]="commonBarSparklineOptions.plotOptions" [tooltip]="commonBarSparklineOptions.tooltip"></apx-chart>
